<template>
  <h1>PROJECTS LIST</h1>
  <project-item
    v-for="proj in projects"
    :key="proj.id"
    :project="proj"
  ></project-item>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import ProjectItem from "./ProjectItem.vue";
export default {
  components: { ProjectItem },
  setup() {
    const store = useStore();
    async function getProjects() {
      await store.dispatch("getProjects");
    }
    getProjects();

    const projects = computed(() => {
      return store.getters.projects;
    });

    return {
      projects
    };
  }
};
</script>
